import React, { useEffect, useState } from 'react';
import { motion, useScroll, useSpring, useMotionValueEvent } from 'framer-motion';

const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 22, mass: 0.2 });
  const [pct, setPct] = useState(0);

  useMotionValueEvent(scrollYProgress, 'change', (v) => setPct(Math.round(v * 100)));

  return (
    <>
      <motion.div
        style={{ scaleX, transformOrigin: '0% 50%' }}
        className="fixed top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-[#c8942a] via-[#f0c95a] to-[#b8331f] z-[60] shadow-[0_0_20px_2px_rgba(200,148,42,0.5)]"
      />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: pct > 4 && pct < 96 ? 1 : 0 }}
        transition={{ duration: 0.4 }}
        className="fixed bottom-24 left-6 z-[60] pointer-events-none hidden md:block"
      >
        <div className="flex items-center gap-3 bg-[#0f0d0b]/70 backdrop-blur-md border border-[#c8942a]/40 px-3 py-1.5 text-[10px] uppercase tracking-[0.3em] font-sans-pro text-white/80">
          <span className="w-1.5 h-1.5 rounded-full bg-[#f0c95a] animate-pulse" />
          <span className="font-serif-display text-white font-black text-xs tabular-nums">{String(pct).padStart(2, '0')}</span>
          <span className="text-white/50">/</span>
          <span className="text-white/50">100</span>
        </div>
      </motion.div>
    </>
  );
};

export default ScrollProgress;
